import Backbone from 'backbone';
import Model from './InterfaceJobModel';
import Globals from '../../../utils/Globals';

const Collection = Backbone.Collection.extend({
    url: Globals.baseUrl + 'interfaces/job',
    model: Model
});
export default Collection;
